import { Component, ViewContainerRef, Inject, TemplateRef } from '@angular/core';
import { PagerService } from '../../services/shared/pager.service';
import { SettingShipmentRulesService } from '../../services/SettingShipmentRules/SettingShipmentRules.service';
import { SettingShipmentRules } from '../../models/SettingShipmentRules/SettingShipmentRules-model';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ShippmentService } from '../../services/shippment/shippment-setting';
import { Shippment } from '../../models/shippment/shippment-model';
import { ToastsManager } from 'ng2-toastr';
import { Router } from '@angular/router';
import { RolePermissionService } from '../../services/role/role-permission.service';
@Component({
  selector: 'app-SettingShipmentRules-list',
  templateUrl: './SettingShipmentRules-list.component.html',
  styleUrls: ['./SettingShipmentRules-list.component.scss']
})
/** SettingShipmentRules-List component*/
export class SettingShipmentRulesListComponent {
  public SettingShipmentRulesList: SettingShipmentRules[];
  public SettingShipmentRules = new SettingShipmentRules();
  // pager object
  pager: any = {};
  searchQuery: string;
  isDisable = true;
  public subscriberList: Shippment[];
  isUpdate = false;
  //isSubmitted = true;
  pageSize: number;
  // paged items
  pagedItems: any[];
  filteredItems: any[];
  public rowsOnPage: number;
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  /** coupons-list ctor */
  constructor(private readonly SettingShipmentRulessService: SettingShipmentRulesService,
    private readonly utilitiesService: UtilitiesService,
    vcr: ViewContainerRef,
    private readonly router: Router, private readonly shipmentService: ShippmentService,
    public toastr: ToastsManager,
    private readonly pagerService: PagerService, private readonly rolePermissionService: RolePermissionService) {
    this.toastr.setRootViewContainerRef(vcr);
    this.rolePermissionService.GetRolePermissions("shippmentdeliveryduration").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.getSettingShipmentRuless();
          this.pageSize = 10;
          this.getSettingShipmentRuless();
          this.GetRowsPerPageList();
          this.getShippingMethods();
            this.SettingShipmentRules.shipmentMethodId = null;
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  getShippingMethods() {
    this.shipmentService.GetActiveShippingMethods().subscribe(
      data => {
        this.subscriberList = data;
      }
    )
  }


  deleteSettingShipmentRules(id) {

    var ans = confirm("Are you sure to delete this shipment duration?");
    if (ans) {
      if (this.SettingShipmentRulessService.deleteSettingShipmentRules(id)) {
        this.toastr.success('Shipment duration has been Deleted.', 'Success');
        this.getSettingShipmentRuless();
      }
      ;
      // setTimeout(, 1000);
    }
  }
  getSettingShipmentRuless() {

    this.SettingShipmentRulessService.getSettingShipmentRules().subscribe(
      data => {
       
        this.SettingShipmentRulesList = data
        this.filteredItems = data;
      }

    )
  }
  setPage(page: number) {

    // get pager object from service
    this.pager = this.pagerService.getPager(this.SettingShipmentRulesList.length, page, this.pageSize);

    // get current page of items
    this.pagedItems = this.SettingShipmentRulesList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch(searchText: string) {

    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.SettingShipmentRulesList, searchText);

    } else {
      this.filteredItems = this.SettingShipmentRulesList;
    }
  }
  editSettingShipmentRulesById(id: string) {
    this.SettingShipmentRulessService.getSettingShipmentRulesById(id).subscribe(
      data => {
        
        this.isUpdate = true;
        this.SettingShipmentRules = data;
        var dim=data.dimension.split(',');
        (<HTMLInputElement>document.getElementById("dim1")).value = dim[0];
        (<HTMLInputElement>document.getElementById("dim2")).value = dim[1];
        (<HTMLInputElement>document.getElementById("dim3")).value = dim[2];
        //(<HTMLInputElement>document.getElementById("add")).T =
        
       
      }
    )
    try {
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  }
  ngSubmit(template: any) {

    this.isDisable = false;
    var result = "";
    var dim1 = ((document.getElementById("dim1") as HTMLInputElement).value);
    var dim2 = ((document.getElementById("dim2") as HTMLInputElement).value);
    var dim3 = ((document.getElementById("dim3") as HTMLInputElement).value);
    if (parseInt(dim1) >= 0 || dim1 == '') {
      if (dim1 == '')
        result += 0;
      else
      result += dim1;
    }
    if (parseInt(dim2) >= 0 || dim2 == '') {
      if (dim2 == '')
        result += ',' +0;
      else
      result += ','+dim2  ;
    }
    if (parseInt(dim3) >= 0 || dim3 == '') {
      if (dim3 == '')
        result += ',' +0;
      else
      result +=  ','+dim3 ;
    }
    this.SettingShipmentRules.dimension = result;
    if (this.isUpdate == false) {
      
      this.SettingShipmentRulessService.addSettingShipmentRules(this.SettingShipmentRules).subscribe(
        data => {
         
          template.submitted = false;
          if (data) {
            this.toastr.success('Shipment duration has been Saved.', 'Success');
            this.SettingShipmentRules.days = "";
            (<HTMLInputElement>document.getElementById("dim1")).value = "";
            (<HTMLInputElement>document.getElementById("dim2")).value = "";
            (<HTMLInputElement>document.getElementById("dim3")).value = "";
            this.SettingShipmentRules.weight = "";
            this.getSettingShipmentRuless();
          }
          else {
            this.toastr.error('Error occurred. Please try again', 'Success');

          }
          this.isDisable = true;

        });
    }
    else {
      this.updateFunction(template);
    }
  }
  updateFunction(template: any) {

  template.submitted = false;

    this.SettingShipmentRulessService.updateSettingShipmentRules(this.SettingShipmentRules).subscribe(
      data => {
       // this.isSubmitted = false;    
        if (data) {
          this.toastr.success('Shipment duration has been Updated.', 'Success');
          this.isUpdate = false;
          this.SettingShipmentRules.days = "";
          (<HTMLInputElement>document.getElementById("dim1")).value = "";
          (<HTMLInputElement>document.getElementById("dim2")).value = "";
          (<HTMLInputElement>document.getElementById("dim3")).value = "";
          this.SettingShipmentRules.weight = "";
          this.getSettingShipmentRuless();
        }
        else {
          this.toastr.error('Error occurred. Please try again', 'Success');
          
        }
        this.isDisable = true;
        
      });


  }
  keyPress(event: any) {
      let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;

    var dim1 = ((document.getElementById("dim1") as HTMLInputElement).value);
    var dim2 = ((document.getElementById("dim2") as HTMLInputElement).value);
    var dim3 = ((document.getElementById("dim3") as HTMLInputElement).value);
    if (typeof dim1 != 'undefined' && dim1 != '') {
    if (parseInt(dim1) < 0) {
      (<HTMLInputElement>document.getElementById("dim1")).value = "0";
      }
    }
    if (typeof dim2 != 'undefined' && dim2!='' ) {
    if (parseInt(dim2) < 0) {
      (<HTMLInputElement>document.getElementById("dim2")).value = "0";
    }
    }
    if (typeof dim3 != 'undefined' && dim3 != '') {
    if (parseInt(dim3) < 0) {
      (<HTMLInputElement>document.getElementById("dim3")).value = "0";
    }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/SettingShipmentRules/SettingShipmentRules-list/SettingShipmentRules-list.component.ts